const SET_FIRST_SPIN_MODAL_OPEN =
  'GAMIFICATION/SPIN_AND_WIN/SET_FIRST_MODAL_OPEN'

export { SET_FIRST_SPIN_MODAL_OPEN }
